import React, { useState } from "react";
import { Button, Dropdown, Table } from "react-bootstrap";
import { FaFileExport, FaPlus } from "react-icons/fa";
import { HiOutlineHome } from "react-icons/hi";

import { Row, Col, Breadcrumb } from "react-bootstrap";
import { FiDownload, FiChevronUp } from "react-icons/fi";
import { FaRegFileAlt } from "react-icons/fa";
import { RiHome6Line, RiArrowRightSLine } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import AddLeaveModal from "../../../components/modals/dashboard/hr-dashboard/AddLeaveModal";
import LeaveOverviewCards from "../../../components/Dashboard/hr-dashboard/LeaveOverviewCards";
import LeaveEmployeesList from "../../../components/Dashboard/hr-dashboard/LeaveEmployeesList";

const initialLeaves = [
  {
    id: 1,
    type: "Medical Leave",
    from: "14 Jan 2024",
    to: "15 Jan 2024",
    days: "2 Days",
    name: "Doglas Martini",
    role: "Manager",
    avatar: "/assets/img/users/user-34.jpg",
    status: "Approved",
    session: "Full Day",
    reason: "Hospital visit",
  },
  {
    id: 2,
    type: "Annual Leave",
    from: "21 Jan 2024",
    to: "25 Jan 2024",
    days: "5 Days",
    name: "Doglas Martini",
    role: "Manager",
    avatar: "/assets/img/users/user-34.jpg",
    status: "Approved",
    session: "Full Day",
    reason: "Vacation",
  },
  {
    id: 3,
    type: "Medical Leave",
    from: "20 Jan 2024",
    to: "22 Feb 2024",
    days: "3 Days",
    name: "Warren Morales",
    role: "Admin",
    avatar: "/assets/img/users/user-58.jpg",
    status: "Approved",
    session: "Full Day",
    reason: "Medical",
  },
  {
    id: 4,
    type: "Casual Leave",
    from: "12 Apr 2024",
    to: "16 Apr 2024",
    days: "5 Days",
    name: "Doglas Martini",
    role: "Manager",
    avatar: "/assets/img/users/user-34.jpg",
    status: "Declined",
    session: "Full Day",
    reason: "Personal",
  },
  {
    id: 5,
    type: "Medical Leave",
    from: "02 Sep 2024",
    to: "04 Sep 2024",
    days: "3 Days",
    name: "Doglas Martini",
    role: "Manager",
    avatar: "/assets/img/users/user-34.jpg",
    status: "New",
    session: "Full Day",
    reason: "Check-up",
  },
];

const LeaveEmployeesPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [leaves, setLeaves] = useState(initialLeaves);

  const handleAddLeave = (newLeaveData) => {
    const newLeave = {
      ...newLeaveData,
      id: Date.now(),
      status: "New",
    };
    setLeaves([...leaves, newLeave]);
    setShowModal(false);
  };

  const handleUpdateLeave = (updatedLeave) => {
    setLeaves(
      leaves.map((leave) =>
        leave.id === updatedLeave.id ? updatedLeave : leave,
      ),
    );
  };

  const handleDeleteLeave = (id) => {
    setLeaves(leaves.filter((leave) => leave.id !== id));
  };

  return (
    <div style={{ padding: "20px", background: "#f5f6f8" }}>
      {/* PAGE HEADER */}

      <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
        <Col md={6} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Leaves</h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
               
                  }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Attendance
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Leaves</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        <div className="d-flex flex-wrap gap-2">
          {/* EXPORT */}

          <Dropdown>
            <Dropdown.Toggle
              variant="light"
              style={{
                border: "1px solid #e5e7eb",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <FaFileExport /> Export
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>Export as PDF</Dropdown.Item>

              <Dropdown.Item>Export as Excel</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* ADD AGENT */}

          <Button
            onClick={() => setShowModal(true)}
            style={{
              background: "#f26522",
              border: "none",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <FaPlus /> Add Leave
          </Button>
        </div>
      </div>

      {/* AGENTS TABLE */}

      {/* <Table bordered responsive>

<thead style={{background:"#f8f9fa"}}>

<tr>

<th>Name</th>

<th>Phone</th>

<th>Email</th>

<th>Department</th>

<th>Designation</th>

</tr>

</thead>

<tbody>

{agents.map(agent=>(
<tr key={agent.id}>

<td>{agent.name}</td>

<td>{agent.phone}</td>

<td>{agent.email}</td>

<td>{agent.department}</td>

<td>{agent.designation}</td>

</tr>
))}

</tbody>

</Table> */}

      {/* MODAL */}

      <AddLeaveModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        onAddLeave={handleAddLeave}
      />
      <LeaveOverviewCards />
      <LeaveEmployeesList
        leaves={leaves}
        onUpdateLeave={handleUpdateLeave}
        onDeleteLeave={handleDeleteLeave}
      />
    </div>
  );
};

export default LeaveEmployeesPage;
